const MODAL_IMAGE_SELECTOR = '[data-modal-image]';

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalMediaObserver = null;
      }

      hide() {
        this.modalMediaObserver?.disconnect();
        this.modalMediaObserver = null;
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.hydrateActiveMedia();
        this.showActiveMedia();
        this.observeModalMedia();
      }

      hydrateActiveMedia() {
        const activeMediaId = this.openedBy?.getAttribute('data-media-id');
        const activeMedia = activeMediaId ? this.querySelector(`[data-media-id="${activeMediaId}"]`) : null;
        const activeImage = activeMedia?.matches(MODAL_IMAGE_SELECTOR)
          ? activeMedia
          : activeMedia?.querySelector(MODAL_IMAGE_SELECTOR);
        this.hydrateModalMedia(activeImage, 'high');
      }

      hydrateModalMedia(image, priority = 'low') {
        if (!image) return;

        if (!image.hasAttribute('srcset') && image.dataset.modalSrcset) {
          image.setAttribute('srcset', image.dataset.modalSrcset);
        }

        if (image.dataset.modalSrc && image.dataset.modalHydrated !== 'true') {
          image.setAttribute('src', image.dataset.modalSrc);
          image.dataset.modalHydrated = 'true';
        }

        image.setAttribute('fetchpriority', priority);
      }

      observeModalMedia() {
        const container = this.querySelector('[role="document"]');
        if (!container || typeof IntersectionObserver === 'undefined') return;

        this.modalMediaObserver?.disconnect();
        this.modalMediaObserver = new IntersectionObserver(
          (entries) => {
            entries
              .filter((entry) => entry.isIntersecting)
              .forEach((entry) => this.hydrateModalMedia(entry.target, 'low'));
          },
          { root: container, rootMargin: '400px' }
        );

        container.querySelectorAll(MODAL_IMAGE_SELECTOR).forEach((image) => {
          if (image.dataset.modalHydrated !== 'true') this.modalMediaObserver.observe(image);
        });
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!activeMediaId) return;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${activeMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
